import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { defaultContent } from "@/lib/defaultContent";

const ContentContext = createContext(defaultContent);

const applyTheme = (theme) => {
  if (!theme) return;
  const root = document.documentElement;
  const c = theme.colors || {};
  const map = {
    "--brand-primary": c.primary,
    "--brand-primary-dark": c.primaryDark,
    "--brand-cream": c.cream,
    "--brand-surface": c.surface,
    "--brand-heading": c.heading,
    "--brand-muted": c.muted,
  };
  Object.entries(map).forEach(([k, v]) => {
    if (v) root.style.setProperty(k, v);
  });
  const a = theme.align || {};
  if (a.hero) root.style.setProperty("--align-hero", a.hero);
  if (a.heading) root.style.setProperty("--align-heading", a.heading);
  if (a.body) root.style.setProperty("--align-body", a.body);
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    applyTheme(defaultContent.theme);
    api.get("/content").then((r) => {
      setContent(r.data);
      applyTheme(r.data.theme);
    }).catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
